module PortalLibs.Shared.Util


open Elmish
open System
open PortalLibs.Shared
open FSharpPlus

#if !DEBUG
let isDebug = false
#endif
#if DEBUG
let isDebug = true
#endif


let filterItemBySearchTerm<'T> (getters: ('T -> string) list) (term: string) (item: 'T) =
  match term with
  | "" -> true
  | x ->
    let matcher = List.fold (fun acc getter -> (acc + (getter item) + " ")) "" getters

    matcher.ToLower().Contains(x.ToLower())
    || List.fold (fun acc getter -> acc && (getter item) = "") true getters

let resultItemOptForEntity<'T, 'U, 'Z> result (idOpt: 'Z option) idGetter =
  monad {
    let! itemId = idOpt
    return!
      List.tryFind (fun (item: 'T) -> idGetter item = itemId.ToString()) (result |> Result.resultOrEmptyListIfNone)
  }

let setItemOptForEntity<'T, 'U> set (idOpt: int64 option) idGetter =
  monad {
    let! itemId = idOpt
    return! List.tryFind (fun (item: 'T) -> idGetter item = itemId.ToString()) set
  }

let resultItemForEntity<'T, 'U, 'Z> result (idOpt: 'Z option) idGetter (valueGetter: 'T -> 'U) (emptyValue: 'U) =
  resultItemOptForEntity result idOpt idGetter
  |>> valueGetter
  |> Option.defaultValue emptyValue

let filterByAdditionalFields (fields: string list) term =
  match term with
  | "" -> true
  | x ->
    let matcher = (fields |> String.concat " ").ToLower()

    matcher.ToLower().Contains(x.ToLower())

let filterByExactTextField (field: string) term =
  match term with
  | "" -> true
  | x -> field = x

let filterByOptionalField field searchOption =
  match searchOption with
  | None -> true
  | Some id -> field.ToString() = id.ToString()

let filterByIdList (idOpt: int64 option) idList =
  match idList with
  | [] -> true
  | list ->
    match idOpt with
    | None -> false
    | Some field -> list |> List.exists (fun f -> field.ToString() = f.ToString())

let waitForDeps<'T> (deps: bool list) (msg: 'T) action =
  match List.forall id deps with
  | true -> action
  | false -> Cmd.OfAsync.either (fun () -> async { do! Async.Sleep(1000) }) () (fun _ -> msg) (fun _ -> msg)

let ssnIntToDashString (ssn: int) = String.Format("{0:000-00-0000}", ssn)

let cleanPhoneNumber (number: String) =
  number
    .Replace(" ", "")
    .Replace(".", "")
    .Replace("-", "")
    .Replace("(", "")
    .Replace(")", "")
  |> fun number ->
       if number.StartsWith("+1") then
         number.Substring(2)
       else
         number


let isValidUSPhoneNumber (number: string) =
  let regExPattern = @"^[01]?[- .]?(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$"

  let pattern = System.Text.RegularExpressions.Regex(regExPattern)

  number |> pattern.IsMatch
